/**
 * PredefinedLock — small lock glyph marking a Designer-seeded (predefined)
 * catalog row in App-mode lists. Deletion of these rows is Designer-only;
 * the icon is a read-only affordance (no click handler) explaining why.
 */
import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import LockOutlined from '@mui/icons-material/LockOutlined'

export const PredefinedLock: React.FC = () => (
  <Tooltip title="Predefined — delete only in Designer">
    <LockOutlined data-testid="predefined-lock" sx={{ fontSize: 14, color: 'text.secondary' }} />
  </Tooltip>
)
